module.exports = __webpack_public_path__ + "img/av.b2cf9e1f.svg";